import api from "../../axios/chat/index.js";
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default function useTourists() {
    const url = new URL(window.location.href);
    const cc = url.searchParams.get("token");

    // 存入localStorage的key
    const storeKey = `company-${cc}-TouristsId`

    // 获取公司uuid
    const getCompanyId = () => {
        const url = new URL(window.location.href);
        const cc = url.searchParams.get("token");
        // localStorage.setItem(Math.random(), cc)
        // const cc = localStorage.getItem("web-plugin-cc")
        if (cc) {
            return cc
        } else {
            return new Error("没有web-plugin-cc,请联系管理员")
        }
    }

    // 获取浏览器指纹
    const getBrowserFingerprint = async () => {
        // const fpSource = await import('https://openfpcdn.io/fingerprintjs/v3')
        const fpPromise = await FingerprintJS.load()
        const result = await fpPromise.get()

        return result.visitorId
    }

    // 根据浏览器指纹生成,请求接口生成唯一游客id
    const markTouristsId = async () => {
        const visitorId = await getBrowserFingerprint()
        const snowflake_id = getCompanyId()

        const res = await api.getTouristsId({
            fingerprint_id: visitorId,
            snowflake_id
        })
        if (res.code === 200) {
            return res.data.tourist_id
        } else {
            return false
        }
    }

    // 生成游客随机id 13位毫秒级时间戳 + 2位随机数 = 15位
    // const markTouristsId = () => {
    //     let timestamp = (new Date()).valueOf();
    //     let m = Math.floor(Math.random() * 90) + 10;
    //     return timestamp + m
    // }

    // 查询本地游客id
    const queryLocalTouristsId = () => {
        let touristsId = localStorage.getItem(storeKey)
        return touristsId ? touristsId : false
    }

    // 获取游客id
    const getTouristsId = async () => {
        let touristsId = queryLocalTouristsId()

        if (touristsId) {
            return touristsId
        } else {
            const temp = await markTouristsId()
            localStorage.setItem(storeKey, temp)
            return temp
        }
    }

    // 获取所有应用信息
    const getBaseInfo = () => {
        return {
            companyId: getCompanyId(),
            touristsId: queryLocalTouristsId()
        }
    }

    return {
        queryLocalTouristsId,
        getTouristsId,
        getCompanyId,
        getBaseInfo
    }
}
